import React, {Component} from 'react';
import './Card.css'

export default class Card extends Component{
  render(){
    return(
      <div className="Card_main">
          <div className="Card_child_top">
            <h3>{this.props.CardService_title}</h3>
          </div>
          <div className="Card_child_botton">
              <img  src={this.props.CardService_background} alt=""/>
          </div>
      </div>
    );
  }
}